export const PIECES_STATUS = {
  COMPLETED: "completed",
  IDLE: "idle",
  ONGOING: "ongoing",
  DISCONTINUED: "inCompleted",
};

export const PIECES_TITLE = {
  COMPLETED: "Completed",
  IDLE: "Idle",
  ONGOING: "Ongoing",
  DISCONTINUED: "Incompleted",
};
